import React from 'react';
import classes from './TableHeader.module.css';
import { ColumnType } from '../types';
import arrowDown from '../../../assets/icons/arrow-down.svg';

type HeaderProps<T> = {
  columns: ColumnType<T>[];
  nestedHeader?: boolean;
  nestedIndex?: number;
  canExpand?: boolean;
};

const TableHeader = <T,>({
  columns,
  nestedHeader = false,
  nestedIndex = 1,
  canExpand = false,
}: HeaderProps<T>) => {
  if (nestedHeader) {
    return (
      <tr>
        <th style={{ textAlign: 'center' }} className={classes.nestedIndexCell}></th>
        {columns.map((column, index) => (
          <th
            key={index}
            style={{ textAlign: column.align ?? 'left' }}
            className={`${classes.nestedHeaderCell} ${
              index < nestedIndex ? classes.nestedIndexCell : ''
            }`}
          >
            {column.displayName}
          </th>
        ))}
      </tr>
    );
  }
  return (
    <thead>
      <tr>
        {canExpand && <th style={{ textAlign: 'center' }} className={classes.headerCell}></th>}
        {columns.map((column, index) => (
          <th
            key={index}
            style={{ textAlign: column.align ?? 'left' }}
            className={classes.headerCell}
            onClick={column.onSort ? column.onSort : undefined}
          >
            <div className={classes.headerContent}>
              {column.displayName}
              {column.onSort && (
                <img
                  src={arrowDown}
                  style={{
                    transform: column.sortOrder === 'asc' ? 'rotate(0deg)' : 'rotate(180deg)',
                  }}
                />
              )}
            </div>
          </th>
        ))}
      </tr>
    </thead>
  );
};

export { TableHeader };
